import React, { useState } from 'react'
const Newsletters = () => {


    // Form state management
    const [form, setForm] = useState({
        email: '',
        name: '',
        nom: '',
    });
    // Success state for form submission
    const [isSuccess, setIsSuccess] = useState(false);



    // newsletter



    // Handle form input changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Handle form submission to MailerLite API
    const handleSubmit = async (e) => {
        e.preventDefault();

        const apiKey = process.env.REACT_APP_MAILERLITE_API_KEY;

        // Prepare data for API submission
        const data = {
            email: form.email,

            fields: {


                nom: form.nom,
            }


        };

        // Send data to MailerLite API
        const response = await fetch('https://connect.mailerlite.com/api/subscribers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${apiKey}`,
            },
            body: JSON.stringify(data),
        });

        if (response.ok) {
            setIsSuccess(true);
            setForm({ email: '', nom: '' }); // Reset form
        } else {
            setIsSuccess(false);
        }
    };


    return (
        <section className="section-newsletter">

            <div className='inner-container' >


                <div className="description">
                    Envie de suivre mes aventures? Inscrivez vous à ma newsletter pour recevoir plus d'infos dans le futur:
                </div>

                <form onSubmit={handleSubmit} style={{ marginTop: '15px', marginBottom: '15px' }} className="infos-form">
                    <input type="text" className="infos-form-input" placeholder="nom" name="nom" value={form.nom || ''} onChange={handleChange} />
                    <input type="email" className="infos-form-input" placeholder="email" name="email" value={form.email} onChange={handleChange} required />
                    <button type="submit" className="infos-form-button">
                        {isSuccess ? 'Merci ✨' : 'hop!'}
                    </button>
                </form>


                <div className="description">
                    <p className="web-credit">site web par <a href="https://ff87c3.eu/" target="_blank">ff87c3.eu</a></p>
                </div>

            </div>




        </section>
    )
}

export default Newsletters